import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelMonetizationForm } from "~/components/views/app/channel/monetization-form";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/settings/monetization",
)({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.jingle.list.queryOptions({
				channelUid: params.channelUid,
			}),
		);
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();

	const { data: channel } = useSuspenseQuery(
		trpc.channel.find.queryOptions({ channelUid }),
	);

	const { data: jingles } = useQuery(
		trpc.jingle.list.queryOptions({
			channelUid,
		}),
	);

	return <ChannelMonetizationForm channel={channel} jingles={jingles} />;
}
